export default "__VITE_ASSET__DoNviRWe__"